var map = {
	"./af-ZA.json": 7978,
	"./am-ET.json": 8347,
	"./ar.json": 9675,
	"./az-AZ.json": 8925,
	"./bg-BG.json": 5213,
	"./bho-IN.json": 910,
	"./bn-BD.json": 3470,
	"./bs-BA.json": 3316,
	"./ca-ES.json": 7814,
	"./ceb-PH.json": 2284,
	"./ckb.json": 5850,
	"./cs-CZ.json": 8818,
	"./cy-GB.json": 2545,
	"./da-DK.json": 661,
	"./de-DE.json": 8318,
	"./el-GR.json": 8806,
	"./en-AU.json": 2568,
	"./en-GB.json": 3229,
	"./en-US.json": 5458,
	"./es-419.json": 8141,
	"./es-ES.json": 9954,
	"./et-EE.json": 3888,
	"./eu-ES.json": 8663,
	"./fa-IR.json": 1873,
	"./fi-FI.json": 510,
	"./fil-PH.json": 21,
	"./fr-CA.json": 1385,
	"./fr-FR.json": 27,
	"./ga-IE.json": 7038,
	"./gl-ES.json": 5625,
	"./gu-IN.json": 4297,
	"./ha-NG.json": 8527,
	"./he-IL.json": 3251,
	"./hi-IN.json": 7647,
	"./hr-HR.json": 2362,
	"./ht-HT.json": 5937,
	"./hu-HU.json": 7136,
	"./hy-AM.json": 3294,
	"./id-ID.json": 4283,
	"./ig-NG.json": 2207,
	"./is-IS.json": 3523,
	"./it-IT.json": 8067,
	"./ja-JP.json": 7815,
	"./jv-ID.json": 6865,
	"./ka-GE.json": 7235,
	"./kk-KZ.json": 7854,
	"./km-KH.json": 1663,
	"./kn-IN.json": 4655,
	"./ko-KR.json": 7667,
	"./ku.json": 6393,
	"./ky-KG.json": 7539,
	"./ln-CD.json": 5858,
	"./lo-LA.json": 322,
	"./lt-LT.json": 2942,
	"./lv-LV.json": 7191,
	"./mg-MG.json": 6565,
	"./mk-MK.json": 710,
	"./ml-IN.json": 2921,
	"./mn-MN.json": 2321,
	"./mr-IN.json": 4109,
	"./ms-MY.json": 9664,
	"./mt-MT.json": 4143,
	"./my-MM.json": 9867,
	"./ne-NP.json": 4198,
	"./nl-NL.json": 6494,
	"./no-NO.json": 703,
	"./om-ET.json": 7075,
	"./or-IN.json": 8444,
	"./pa-Arab-PK.json": 122,
	"./pa-IN.json": 6649,
	"./pl-PL.json": 2763,
	"./ps-AF.json": 7844,
	"./pt-BR.json": 788,
	"./pt-PT.json": 680,
	"./ro-RO.json": 4303,
	"./ru-RU.json": 8774,
	"./rw-RW.json": 1570,
	"./sd-PK.json": 6046,
	"./si-LK.json": 854,
	"./sk-SK.json": 6986,
	"./sl-SI.json": 3683,
	"./so-SO.json": 9523,
	"./sq-AL.json": 6607,
	"./sr-RS.json": 6609,
	"./su-ID.json": 4045,
	"./sv-SE.json": 8509,
	"./sw-TZ.json": 3000,
	"./ta-IN.json": 4608,
	"./te-IN.json": 3935,
	"./tg-TJ.json": 2844,
	"./th-TH.json": 7403,
	"./tr-TR.json": 5945,
	"./uk-UA.json": 9454,
	"./ur-PK.json": 7453,
	"./uz-UZ.json": 1556,
	"./vi-VN.json": 4406,
	"./xh-ZA.json": 2304,
	"./yo-NG.json": 8191,
	"./yue-HK.json": 2805,
	"./zh-CN.json": 7258,
	"./zh-TW.json": 7974,
	"./zu-ZA.json": 7892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8499;